import { render, staticRenderFns } from "./TicketsGeneratedTable.vue?vue&type=template&id=0dcb8804&scoped=true&"
import script from "./TicketsGeneratedTable.vue?vue&type=script&lang=js&"
export * from "./TicketsGeneratedTable.vue?vue&type=script&lang=js&"
import style0 from "./TicketsGeneratedTable.vue?vue&type=style&index=0&id=0dcb8804&scoped=true&lang=css&"
import style1 from "../../../assets/css/style-tables-dark.css?vue&type=style&index=1&id=0dcb8804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcb8804",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBadge,VBtn,VCard,VCardText,VCardTitle,VDataTable,VIcon,VSimpleTable,VSkeletonLoader,VSpacer,VTextField})
